var map = {
	"./2024-mothers-day/au/desktop.jpg": 40628,
	"./2024-mothers-day/na/desktop.jpg": 31265,
	"./fathersday/desktop.jpg": 84372,
	"./generic/desktop.jpg": 80820,
	"./holiday/desktop.jpg": 11891,
	"./mothersday/au/desktop.jpg": 90580,
	"./mothersday/desktop.jpg": 9279,
	"./mothersday/na/desktop.jpg": 64865,
	"./valentines/desktop.jpg": 90620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64796;